import { toString } from '@utils/date';

export function getDate(date, mask) {
  return toString(date, mask);
}

export default {
  install(Vue) {
    Vue.filter('date', getDate);
  },
};
